import React from 'react'
import { useSelector } from 'react-redux'
import { Box, Tooltip } from '@mui/material'
import DOMPurify from 'dompurify'
import useTooltipEnabled from 'Hooks/useTooltipEnabled'

interface PhotoProps {
  photos?: any
  assetUrl?: string
}

function stripHtmlTags(htmlString) {
  if(htmlString) return htmlString.replace(/<[^>]*>/g, '');
}

const Photos = ({ photos, assetUrl }: PhotoProps) => {
  const { locId } = useSelector((state: any) => state.location)
  const instagramWidth = '800px'
  const instagramHeight = '650px'
  const tooltipEnabled = useTooltipEnabled()

  return (
    <>
      {photos?.map((photo: any) => { 
        const descriptionPart =
          photo.accessibility_description ||
          stripHtmlTags(photo.description) ||
          ''
        const accessibilityText = [photo.title, descriptionPart]
          .filter((part) => part != null && String(part).trim() !== '')
          .join('. ')
        const imageAlt = accessibilityText || 'Photo'
        return (
          <div
            key={
              photo.photoid || photo.hotspotMediaId || photo.media_id
            }
          >
            <h4>{photo.title}</h4>
            <Box
              component={'div'}
              sx={{
                maxWidth: '100%',
                maxHeight: '450px',
                background: '#f2f3f4',
                textAlign: 'center',
                overflow: 'scroll',
              }}
            >
              <Tooltip title={accessibilityText || imageAlt} placement='top' arrow disableHoverListener={!tooltipEnabled} disableFocusListener={!tooltipEnabled} disableTouchListener={!tooltipEnabled}>
              {photo.network !== 'instagram' ? (
                <Box
                  component='img'
                  sx={{
                    maxHeight: '450px',
                    maxWidth: '100%',
                  }}
                  alt={imageAlt}
                  src={`${assetUrl}/media/${locId}/photos/${
                    photo.photoid || photo.hotspotMediaId || photo.media_id
                  }/1024.jpg`}
                />
              ) : (
                <iframe
                  aria-hidden='true'
                  src={`https://www.instagram.com/p/${photo.url}/embed`}
                  title='Instagram video player'
                  frameBorder='0'
                  scrolling='true'
                  width={instagramWidth}
                  height={instagramHeight}
                  style={{
                    maxWidth: instagramWidth,
                    maxHeight: instagramHeight,
                    width: '100%',
                  }}
                  data-testid={`instagram-video-${photo.photoid}`}
                />
              )}
              </Tooltip>
            </Box>

            <p
              dangerouslySetInnerHTML={{
                __html: DOMPurify.sanitize(photo.description, {
                  ADD_ATTR: ['target'],
                }),
              }}
            />
          </div>
        )
      })}
    </>
  )
}

export default Photos
